import { apiClient } from './api'

export interface LocalizationPrefs {
  date_format: 'MM/DD/YYYY' | 'DD/MM/YYYY' | 'YYYY-MM-DD'
  time_format: '12h' | '24h'
  number_format: '1,234.56' | '1.234,56' | '1 234,56'
  currency: string
  timezone: string
}

export const localizationService = {
  async get(): Promise<LocalizationPrefs> {
    const response = await apiClient.get<LocalizationPrefs>('/api/v1/preferences/localization')
    return response.data
  },

  async update(patch: Partial<LocalizationPrefs>): Promise<LocalizationPrefs> {
    const response = await apiClient.put<LocalizationPrefs>('/api/v1/preferences/localization', patch)
    return response.data
  },
}
